<template>
  <VContainer id="bundle-items-content" class="d-lg-inline-block">
    <div class="pa-3 p-lg-0">
      <SurpriseItems v-if="bundleItemsHidden" :items="product.bundle_items" />
      <WideProductTileList
        v-else
        :products-to-fetch="productsToFetch"
        item-list-id="bundle_items"
        data-elbcontext="shopping:discover;wide_product_tile:bundle_items"
      />
    </div>
  </VContainer>
</template>

<script>
import { usePdpStore } from '@/stores/pdp'
import { mapState } from 'pinia'
import { defineAsyncComponent } from 'vue'

const WideProductTileList = defineAsyncComponent(
  () => import('@/components/pdp/atoms/WideProductTileList.vue')
)
const SurpriseItems = defineAsyncComponent(
  () => import('@/components/pdp/atoms/SurpriseItems.vue')
)

export default {
  components: { SurpriseItems, WideProductTileList },
  computed: {
    ...mapState(usePdpStore, { product: 'getApiProduct' }),
    productsToFetch() {
      return (
        this.product.bundle_items?.map((item) => ({
          product_id: item.product_id,
          campaign_id: item.campaign_id
        })) ?? []
      )
    },
    bundleItemsHidden() {
      return this.product.design?.bundle_items_hidden
    }
  }
}
</script>
